import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { h } from '@debbie/cortex/dist';
import THEME from '../theme';
import Errors from './Errors';
import { ArrowLeft, ArrowRight } from './Icons';
import PowerView from './power-table/View';
const RemoteTable = (props) => {
    const lang = useSelector((s) => s.lang);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(props.initFilters);
    const [sortKey, setSortKey] = useState(undefined);
    const [sortDirection, setSortDirection] = useState('ASC');
    const loader = props.useFetch(filters, page, props.pageSize);
    const updateFilter = (dispatch) => {
        setFilters(dispatch);
        setPage(0);
    };
    const updateSortKey = (key) => {
        setSortKey(key);
        setFilters((f) => (Object.assign(Object.assign({}, f), { [props.sortKeyKey]: key })));
    };
    const updateSortDirection = (direction) => {
        setSortDirection(direction);
        setFilters((f) => (Object.assign(Object.assign({}, f), { [props.sortDirectionKey]: direction })));
    };
    const [inpPage, setInpPage] = useState('0');
    useEffect(() => {
        setInpPage(`${page + 1}`);
    }, [page]);
    return (React.createElement("div", null,
        h.isError(loader) ? React.createElement(Errors, { errors: [loader.error.message] }) : null,
        React.createElement(PaginationWrapper, { top: true },
            React.createElement(PaginationButton, { onClick: () => {
                    setPage(Math.max(0, page - 1));
                } },
                React.createElement(ArrowLeft, null)),
            React.createElement(Inp, { value: inpPage, onChange: (e) => {
                    const inputValue = e.currentTarget.value;
                    if (/^\d*$/.test(inputValue) && inputValue !== '0') {
                        setInpPage(inputValue);
                        const val = parseInt(inputValue);
                        if (!Number.isNaN(val)) {
                            setPage(Math.max(0, val - 1));
                        }
                    }
                } }),
            React.createElement(PaginationButton, { onClick: () => {
                    setPage(page + 1);
                } },
                React.createElement(ArrowRight, null))),
        props.selectable ? (React.createElement(PowerView, { selectable: props.selectable, selected: props.selected, onSelect: props.onSelect, selectKey: props.selectKey, filter: filters, setFilter: updateFilter, loading: h.isLoading(loader) || h.isReloading(loader), genKey: props.genKey, data: h.hasData(loader) ? loader.data.items : [], sortKey: sortKey, onClick: props.onClick, updateSortKey: (key) => updateSortKey(key), direction: sortDirection, updateSortDirection: (dir) => updateSortDirection(dir), values: props.values })) : (React.createElement(PowerView, { filter: filters, setFilter: updateFilter, loading: h.isLoading(loader) || h.isReloading(loader), genKey: props.genKey, data: h.hasData(loader) ? loader.data.items : [], sortKey: sortKey, onClick: props.onClick, updateSortKey: (key) => updateSortKey(key), direction: sortDirection, updateSortDirection: (dir) => updateSortDirection(dir), values: props.values })),
        React.createElement(PaginationWrapper, { top: false },
            React.createElement(PaginationButton, { onClick: () => {
                    setPage(Math.max(0, page - 1));
                } },
                React.createElement(ArrowLeft, null)),
            React.createElement(Inp, { value: inpPage, onChange: (e) => {
                    const inputValue = e.currentTarget.value;
                    if (/^\d*$/.test(inputValue) && inputValue !== '0') {
                        console.log(inputValue);
                        setInpPage(inputValue);
                        const val = parseInt(inputValue);
                        if (!Number.isNaN(val)) {
                            setPage(Math.max(0, val - 1));
                        }
                    }
                } }),
            React.createElement(PaginationButton, { onClick: () => {
                    setPage(page + 1);
                } },
                React.createElement(ArrowRight, null)))));
};
const Pagination = styled.div `
  padding: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
  flex-direction: ${(p) => (p.type === 'pages' ? 'row' : 'column')};
`;
const PaginationWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${(props) => (props.top ? 'lightgray' : '#f0f0f0')};
  color: ${THEME.COLOR_PRIMARY};
`;
const PaginationButton = styled.button `
  background: none;
  color: inherit;
  border: none;
  padding: 0.5em;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  color: ${THEME.COLOR_PRIMARY};
`;
const Inp = styled.input `
  border: none;
  background-image: none;
  background-color: transparent;
  box-shadow: none;
  text-align: center;
  width: 60px;
`;
export default RemoteTable;
//# sourceMappingURL=RemoteTable.js.map